import { usePostHog } from "posthog-js/react";
import type React from "react";

import { ThumbsDownIcon } from "@/components/Icons/ThumbsDownIcon";
import { ThumbsUpIcon } from "@/components/Icons/ThumbsUpIcon";
import { Modal, type ModalBaseProps } from "@/components/Modal/Modal";
import { MultiLineContent } from "@/components/MultiLineContent/MultiLineContent";
import { Button } from "@/design-system/Button";
import { useTranslation } from "@/translations";

type SurveyFollowUpModalProps = ModalBaseProps & {
  surveyId: string;
};
export function SurveyFollowUpTipsModal_LEGACY({
  surveyId,
  isOpened,
  onOpenChange,
}: SurveyFollowUpModalProps): React.ReactNode {
  const { t } = useTranslation();
  const postHog = usePostHog();
  const handleAgree = () => {
    postHog.capture("clicked_survey_follow_up_agree", {
      surveyId,
    });
    onOpenChange(false);
  };
  const handleDisagree = () => {
    postHog.capture("clicked_survey_follow_up_disagree", {
      surveyId,
    });
    onOpenChange(false);
  };

  return (
    <Modal.Root
      size="md"
      title={t("page.survey-details.follow-up-modal.title")}
      description={t("page.survey-details.follow-up-modal.description")}
      {...{
        isOpened,
        onOpenChange,
      }}
    >
      <Modal.Body>
        <section className="py-space-sm text-body">
          <MultiLineContent>{t("page.survey-details.follow-up-modal.body")}</MultiLineContent>
        </section>
      </Modal.Body>

      <Modal.Actions>
        <Modal.Close>
          <Button variant="outline" icon={<ThumbsDownIcon />} onClick={() => handleDisagree()}>
            {t("page.survey-details.follow-up-modal.disagree.btn")}
          </Button>
        </Modal.Close>
        <Modal.Close>
          <Button icon={<ThumbsUpIcon />} onClick={handleAgree}>
            {t("page.survey-details.follow-up-modal.agree.btn")}
          </Button>
        </Modal.Close>
      </Modal.Actions>
    </Modal.Root>
  );
}
